export default __webpack_public_path__ + "21eb58aa03f607a507a84c5541d7d2dc.json";